module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0UlEQVQ4y6XUvQ2DMBCG4deZwBvACBkhA6RgBEZgDMqM4IoBUlEyAgOgzECV1mk+IX7y43MsWZZPukcn+2xijFgn0AB+E8tAAjAD4xo7YRjOuQCcgVLQ4JzzADmVdLvYCHgLMgKF1qC4F95YEA9UwFX7boMakBqIwgpVcv95ax+QWvulkq+QFXkL5SAHCOhzkA2kQ4zApKZLRvbQALTAE3gIS0IWSC0flVgIm1KRNXTbdWsruE9+QkqedR5BwABUxl9huZ1ZlZU5f5QDLkoO/DFeppdJ3w9Syb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Pencil.png
// module id = 61
// module chunks = 0 1